import React from "react";

import { Box, Card, CardContent, Grid, Skeleton } from "@mui/material";

export default function BlockCardSkeleton({ animation = "wave", quantity = 6 }) {
  const cardSkeleton = () => {
    return (
      <Grid item xs={12} sm={6} md={4} lg={4} sx={{ display: 'flex', justifyContent: 'center' }}>
        <Card sx={{ width: 250, height: 180 }} elevation={0}>
          <CardContent sx={{ flexGrow: 1, p: 3, width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <Skeleton
              variant="circular"
              width="80px"
              height="80px"
              sx={{ borderRadius: 1 }}
            />

            <Skeleton variant="text" width={120} height={28} animation={animation} />
          </CardContent>
        </Card>
      </Grid>
    )
  }

  return (
    <Grid container item justifyContent="center" alignItems="center" spacing={3} mb={2}>
      {Array.from({ length: quantity }, (_, index) => (
        <React.Fragment key={index}>
          {cardSkeleton()}
        </React.Fragment>
      ))}
    </Grid>
  )
}